import { TSortingDirection } from '@/types';
import { useCallback, useState } from 'react';

const DEFAULT_SORTING_DIRECTION = 'desc';

interface Props<TColumn> {
  defaultSortingColumn: TColumn;
  defaultSortingDirection?: TSortingDirection;
}

export const useTableColumnSort = <TColumn>({ defaultSortingColumn, defaultSortingDirection }: Props<TColumn>) => {
  const [sortingColumn, setSortingColumn] = useState<TColumn>(defaultSortingColumn);
  const [sortingDirection, setSortingDirection] = useState<TSortingDirection>(
    defaultSortingDirection ? (defaultSortingDirection as TSortingDirection) : DEFAULT_SORTING_DIRECTION,
  );

  const updateSortingColumn = useCallback(
    (clickedColumn: TColumn) => {
      if (clickedColumn === sortingColumn) {
        setSortingDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
      } else {
        setSortingColumn(clickedColumn);
        setSortingDirection(DEFAULT_SORTING_DIRECTION);
      }
    },
    [sortingColumn],
  );

  return { sortingColumn, sortingDirection, updateSortingColumn };
};
